import { Card, CardContent, CardHeader, Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MapItTextField } from "src/components/common";
import { TextFieldNumber } from "src/_modules/common";
import { MapItLocalizedNumberTextField } from "src/components/common";
import { useSelector } from "react-redux";

export default function OrderBasicInfoCard({ order, handleChange, validationErrors }) {
    const { t } = useTranslation()
    const profile = useSelector((state) => state.entities.profile)
    return (
        <Card>
            <CardHeader title={t("Order Details")} />
            <Divider />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextFieldNumber
                            fullWidth
                            size="small"
                            decimal={false}
                            label={t("Package Count")}
                            name="packagesCount"
                            value={order?.packagesCount ?? ""}
                            onChange={handleChange}
                            error={validationErrors?.packagesCount}
                            required={true}
                            max={999999}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextFieldNumber
                            fullWidth
                            size="small"
                            label={t("Weight")}
                            name="weight"
                            value={order?.weight ?? ''}
                            onChange={handleChange}
                            helperText={validationErrors?.weight ?? ''}
                            error={!!validationErrors?.weight}
                            max={999999}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MapItLocalizedNumberTextField
                            label={t("COD (Cash On Delivery)")}
                            name="amountPayable"
                            value={order?.amountPayable ?? ""}
                            handleChange={handleChange}
                            error={validationErrors?.amountPayable}
                            max={999999}
                        />
                    </Grid>
                    {(!!profile?.profile && profile?.profile?.merchant?.shippingType === "FIRST_MILE")
                        &&
                        <Grid item xs={12} md={6}>
                            <MapItTextField
                                fullWidth
                                label={t("Order reference number")}
                                name="trackingNumber"
                                size="small"
                                value={order?.trackingNumber ?? ""}
                                handleChange={handleChange}
                                error={validationErrors?.trackingNumber}
                            />
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}